import { computed } from 'vue';
import { useStore } from 'vuex';
import { UserRole, ROLE_GROUPS } from '@/constants/roles';
import { Permission } from '@/constants/permissions';
import {
    getUserRoles,
    storeHasRole,
    storeHasAnyRole,
    storeHasAllRoles,
    storeIsInGroup,
    storeCan,
} from '@/utils/authFromStore';

/**
 * Права и роли для script setup: функции возвращают boolean на момент вызова
 * (в шаблоне / внутри computed отслеживается реактивность store).
 */
export const useAuth = () => {
    const store = useStore();

    const userRoles = computed((): UserRole[] => getUserRoles(store));

    const hasRole = (role: UserRole): boolean => storeHasRole(store, role);
    const hasAnyRole = (roles: UserRole[]): boolean => storeHasAnyRole(store, roles);
    const hasAllRoles = (roles: UserRole[]): boolean => storeHasAllRoles(store, roles);
    const isInGroup = (groupName: keyof typeof ROLE_GROUPS): boolean =>
        storeIsInGroup(store, groupName);
    const can = (permission: Permission): boolean => storeCan(store, permission);

    return {
        userRoles,
        hasRole,
        hasAnyRole,
        hasAllRoles,
        isInGroup,
        can,
    };
};
